/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_EyebrowInputs */

const en_directory_comparison_product_hunt_eyebrow = /** @type {(inputs: Directory_Comparison_Product_Hunt_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI vs Product Hunt`)
};

const zh_directory_comparison_product_hunt_eyebrow = /** @type {(inputs: Directory_Comparison_Product_Hunt_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 对比 Product Hunt`)
};

/**
* | output |
* | --- |
* | "Seek AI vs Product Hunt" |
*
* @param {Directory_Comparison_Product_Hunt_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_eyebrow = /** @type {((inputs?: Directory_Comparison_Product_Hunt_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_eyebrow(inputs)
	return zh_directory_comparison_product_hunt_eyebrow(inputs)
});
export { directory_comparison_product_hunt_eyebrow as "directory.comparison.product_hunt.eyebrow" }